// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/wood-grain-pattern.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Footer — Start Journey | Support Mission + swatch band
   All type values mirror the client's existing component styles
   ============================================================ */

.ftr {
  background: var(--c-cream);
  border-top: 1px solid var(--line);
  overflow: hidden;
}

/* ─────────────────────────────────────────────────────────────
   CTA two-panel row
   grid: illustration | panel | OR | panel | illustration
───────────────────────────────────────────────────────────── */
.ftr__cta {
  display: grid;
  grid-template-columns:
    auto /* journey */
    clamp(58px, 6vw, 80px) /* OR */
    auto /* mission */;
  align-items: stretch;
  min-height: clamp(340px, 48vw, 520px);
  border-bottom: 1px solid var(--line);
  overflow: hidden;
}

.ftr__panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: clamp(1rem, 2vw, 1.6rem);

  border-right: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.ftr__panel:last-of-type {
  border-right: none;
}

.innerContent {
  position: relative;
  z-index: 9;
  padding: clamp(2.5rem, 5vw, 4.5rem) clamp(1.75rem, 3.5vw, 3rem);
}
.innerContent div {
  min-width: 60%;
}

/* ── Illustration columns ── */
.ftr__illustration {
  height: 100%;
  position: relative;
  width: 100%;
}

.ftr__illustration--left img {
  position: absolute;
  bottom: -10%;
  left: -10%;
  width: 50%;
  height: auto;
}
.ftr__illustration--right img {
  position: absolute;
  bottom: -50%;
  right: -15%;
  width: 80%;
  height: auto;
}

/* ── Content panels ── */

/* Headlines — Anton display, matching u-display */
.ftr__headline {
  /* u-display applied via className; just set size here */
  font-size: clamp(2rem, 4.5vw, 3.8rem);
  line-height: 0.99;
  margin: 0;
}

.ftr__headline--forest {
  color: var(--c-forest);
}
.ftr__headline--rust {
  color: var(--accent);
}

/* Sub-copy — Inter 400, muted, matches client body style */
.ftr__sub {
  font-family: var(--font-body);
  font-size: clamp(0.88rem, 1.1vw, 1rem);
  font-weight: 400;
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0;
}

/* ── Email form ── */
.ftr__form {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  max-width: 100%;
}

.ftr__input {
  width: 100%;
  border: 1px solid rgba(27, 27, 27, 0.32);
  border-radius: var(--radius-sm);
  background: transparent;
  padding: 0.85rem 1rem;
  font-family: var(--font-body);
  font-size: var(--fs-body);
  font-weight: 400;
  color: var(--c-ink);
  outline: none;
  transition: border-color var(--dur) var(--ease);
}
.ftr__input::placeholder {
  color: var(--text-muted);
}
.ftr__input:focus {
  border-color: var(--accent);
}

/* ── Buttons — Inter 600, tracked caps, matching hero CTA style ── */
.ftr__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 0.72rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  border: none;
  border-radius: 0;
  padding: 0.9rem 1.5rem;
  max-width: 22rem;
  width: 100%;
  transition:
    background var(--dur) var(--ease),
    color var(--dur) var(--ease),
    border-color var(--dur) var(--ease);
}

.ftr__btn--filled {
  background: var(--accent);
  color: var(--on-accent);
}
.ftr__btn--filled:hover {
  background: var(--accent-hover);
}

.ftr__btn--outline {
  background: transparent;
  color: var(--c-ink);
  border: 1.5px solid rgba(27, 27, 27, 0.55);
}
.ftr__btn--outline:hover {
  background: var(--c-ink);
  color: var(--c-cream);
}

/* ── OR divider ── */
.ftr__or {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding-block: 2.5rem;
}

.ftr__or-line {
  display: block;
  width: 1px;
  flex: 1 1;
  background: var(--line);
}

.ftr__or-circle {
  font-family: var(--font-body);
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  color: var(--text-muted);
  width: 2.3rem;
  height: 2.3rem;
  border: 1px solid var(--line);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* ─────────────────────────────────────────────────────────────
   Colour swatch band
   grid: meta | 6 tiles | brand block
───────────────────────────────────────────────────────────── */
.ftr__swatches {
  display: grid;
  grid-template-columns: clamp(110px, 12vw, 160px) repeat(6, 1fr) clamp(130px, 15vw, 190px);
  height: clamp(72px, 11vw, 120px);
  border-bottom: 1px solid var(--line);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: bottom;
  background-attachment: fixed;
  background-repeat: repeat-x repeat-y;
  background-size: 25vw;
}

/* Left meta text */
.ftr__swatches-meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.6rem clamp(0.75rem, 1.8vw, 1.5rem);
  border-right: 1px solid var(--line);
  gap: 0.05rem;
}

.ftr__swatches-meta span {
  font-family: var(--font-body);
  font-size: 0.58rem;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--text-muted);
  display: block;
}

.ftr__swatches-cross {
  margin-top: 0.3rem;
  letter-spacing: 0.12em !important;
}

/* Colour tiles */
.ftr__swatch {
  width: 100%;
  height: 100%;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Right brand block */
.ftr__swatches-brand {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 0.6rem 0.75rem;
  border-left: 1px solid var(--line);
  gap: 0.5rem;
}

/* Scale the circular badge down for the band */
.ftr__swatches-brand .wws__badge {
  width: clamp(48px, 5.5vw, 66px) !important;
  height: clamp(48px, 5.5vw, 66px) !important;
}

/* ── Bottom bar ── */
.ftr__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding-block: clamp(0.85rem, 1.4vw, 1.2rem);
}

.ftr__bar-copy {
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 400;
  letter-spacing: 0.06em;
  color: var(--text-muted);
}

.ftr__bar-nav {
  display: flex;
  gap: clamp(0.75rem, 2vw, 1.75rem);
}

.ftr__bar-link {
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
  text-decoration: none;
  transition: color var(--dur) var(--ease);
}
.ftr__bar-link:hover {
  color: var(--accent);
}

/* ── Responsive ── */
@media (max-width: 1099.98px) {
  .ftr__cta {
    grid-template-columns:
      auto
      clamp(50px, 5vw, 68px)
      auto;
  }
  .innerContent div {
    min-width: 100%;
  }
}

@media (max-width: 767.98px) {
  .ftr__cta {
    grid-template-columns: 1fr;
  }

  .ftr__illustration {
    display: none;
  }
  .ftr__or {
    flex-direction: row;
    height: auto;
    padding: 1rem 2rem;
    border-top: 1px solid var(--line);
    border-bottom: 1px solid var(--line);
  }
  .ftr__or-line {
    flex: 1 1;
    width: auto;
    height: 1px;
  }
  .ftr__panel {
    border-left: none;
    border-right: none;
    border-bottom: 1px solid var(--line);
    padding: 2rem var(--gutter);
  }
  .ftr__swatches {
    grid-template-columns: repeat(6, 1fr);
    height: clamp(52px, 12vw, 80px);
  }
  .ftr__swatches-meta,
  .ftr__swatches-brand {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/CTAsec.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;;+DAG+D;AAC/D;EACE,aAAa;EACb;;;sBAGoB;EACpB,oBAAoB;EACpB,qCAAqC;EACrC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;;EAE7B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,+DAA+D;AACjE;AACA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA,yBAAyB;;AAEzB,kDAAkD;AAClD;EACE,wDAAwD;EACxD,qCAAqC;EACrC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;;AAEA,2DAA2D;AAC3D;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,+BAA+B;EAC/B,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,+CAA+C;AACjD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;;AAEA,qEAAqE;AACrE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX;;;uCAGqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;+DAG+D;AAC/D;EACE,aAAa;EACb,yFAAyF;EACzF,gCAAgC;EAChC,oCAAoC;EACpC,yDAAsE;EACtE,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6CAA6C;EAC7C,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,kCAAkC;EAClC,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE;IACE;;;UAGM;EACR;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,SAAO;IACP,WAAW;IACX,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,2BAA2B;EAC7B;EACA;IACE,qCAAqC;IACrC,+BAA+B;EACjC;EACA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* ============================================================\n   Footer — Start Journey | Support Mission + swatch band\n   All type values mirror the client's existing component styles\n   ============================================================ */\n\n.ftr {\n  background: var(--c-cream);\n  border-top: 1px solid var(--line);\n  overflow: hidden;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   CTA two-panel row\n   grid: illustration | panel | OR | panel | illustration\n───────────────────────────────────────────────────────────── */\n.ftr__cta {\n  display: grid;\n  grid-template-columns:\n    auto /* journey */\n    clamp(58px, 6vw, 80px) /* OR */\n    auto /* mission */;\n  align-items: stretch;\n  min-height: clamp(340px, 48vw, 520px);\n  border-bottom: 1px solid var(--line);\n  overflow: hidden;\n}\n\n.ftr__panel {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: clamp(1rem, 2vw, 1.6rem);\n\n  border-right: 1px solid var(--line);\n  border-left: 1px solid var(--line);\n}\n\n.ftr__panel:last-of-type {\n  border-right: none;\n}\n\n.innerContent {\n  position: relative;\n  z-index: 9;\n  padding: clamp(2.5rem, 5vw, 4.5rem) clamp(1.75rem, 3.5vw, 3rem);\n}\n.innerContent div {\n  min-width: 60%;\n}\n\n/* ── Illustration columns ── */\n.ftr__illustration {\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n\n.ftr__illustration--left img {\n  position: absolute;\n  bottom: -10%;\n  left: -10%;\n  width: 50%;\n  height: auto;\n}\n.ftr__illustration--right img {\n  position: absolute;\n  bottom: -50%;\n  right: -15%;\n  width: 80%;\n  height: auto;\n}\n\n/* ── Content panels ── */\n\n/* Headlines — Anton display, matching u-display */\n.ftr__headline {\n  /* u-display applied via className; just set size here */\n  font-size: clamp(2rem, 4.5vw, 3.8rem);\n  line-height: 0.99;\n  margin: 0;\n}\n\n.ftr__headline--forest {\n  color: var(--c-forest);\n}\n.ftr__headline--rust {\n  color: var(--accent);\n}\n\n/* Sub-copy — Inter 400, muted, matches client body style */\n.ftr__sub {\n  font-family: var(--font-body);\n  font-size: clamp(0.88rem, 1.1vw, 1rem);\n  font-weight: 400;\n  color: var(--text-muted);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* ── Email form ── */\n.ftr__form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  max-width: 100%;\n}\n\n.ftr__input {\n  width: 100%;\n  border: 1px solid rgba(27, 27, 27, 0.32);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  padding: 0.85rem 1rem;\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  font-weight: 400;\n  color: var(--c-ink);\n  outline: none;\n  transition: border-color var(--dur) var(--ease);\n}\n.ftr__input::placeholder {\n  color: var(--text-muted);\n}\n.ftr__input:focus {\n  border-color: var(--accent);\n}\n\n/* ── Buttons — Inter 600, tracked caps, matching hero CTA style ── */\n.ftr__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 0.72rem;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  text-decoration: none;\n  cursor: pointer;\n  border: none;\n  border-radius: 0;\n  padding: 0.9rem 1.5rem;\n  max-width: 22rem;\n  width: 100%;\n  transition:\n    background var(--dur) var(--ease),\n    color var(--dur) var(--ease),\n    border-color var(--dur) var(--ease);\n}\n\n.ftr__btn--filled {\n  background: var(--accent);\n  color: var(--on-accent);\n}\n.ftr__btn--filled:hover {\n  background: var(--accent-hover);\n}\n\n.ftr__btn--outline {\n  background: transparent;\n  color: var(--c-ink);\n  border: 1.5px solid rgba(27, 27, 27, 0.55);\n}\n.ftr__btn--outline:hover {\n  background: var(--c-ink);\n  color: var(--c-cream);\n}\n\n/* ── OR divider ── */\n.ftr__or {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  padding-block: 2.5rem;\n}\n\n.ftr__or-line {\n  display: block;\n  width: 1px;\n  flex: 1;\n  background: var(--line);\n}\n\n.ftr__or-circle {\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.2em;\n  color: var(--text-muted);\n  width: 2.3rem;\n  height: 2.3rem;\n  border: 1px solid var(--line);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   Colour swatch band\n   grid: meta | 6 tiles | brand block\n───────────────────────────────────────────────────────────── */\n.ftr__swatches {\n  display: grid;\n  grid-template-columns: clamp(110px, 12vw, 160px) repeat(6, 1fr) clamp(130px, 15vw, 190px);\n  height: clamp(72px, 11vw, 120px);\n  border-bottom: 1px solid var(--line);\n  background-image: url(\"../../../public/assets/wood-grain-pattern.svg\");\n  background-position: bottom;\n  background-attachment: fixed;\n  background-repeat: repeat-x repeat-y;\n  background-size: 25vw;\n}\n\n/* Left meta text */\n.ftr__swatches-meta {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0.6rem clamp(0.75rem, 1.8vw, 1.5rem);\n  border-right: 1px solid var(--line);\n  gap: 0.05rem;\n}\n\n.ftr__swatches-meta span {\n  font-family: var(--font-body);\n  font-size: 0.58rem;\n  font-weight: 600;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  display: block;\n}\n\n.ftr__swatches-cross {\n  margin-top: 0.3rem;\n  letter-spacing: 0.12em !important;\n}\n\n/* Colour tiles */\n.ftr__swatch {\n  width: 100%;\n  height: 100%;\n  opacity: 0.9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Right brand block */\n.ftr__swatches-brand {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  padding: 0.6rem 0.75rem;\n  border-left: 1px solid var(--line);\n  gap: 0.5rem;\n}\n\n/* Scale the circular badge down for the band */\n.ftr__swatches-brand .wws__badge {\n  width: clamp(48px, 5.5vw, 66px) !important;\n  height: clamp(48px, 5.5vw, 66px) !important;\n}\n\n/* ── Bottom bar ── */\n.ftr__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding-block: clamp(0.85rem, 1.4vw, 1.2rem);\n}\n\n.ftr__bar-copy {\n  font-family: var(--font-body);\n  font-size: 0.7rem;\n  font-weight: 400;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n}\n\n.ftr__bar-nav {\n  display: flex;\n  gap: clamp(0.75rem, 2vw, 1.75rem);\n}\n\n.ftr__bar-link {\n  font-family: var(--font-body);\n  font-size: 0.7rem;\n  font-weight: 500;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  text-decoration: none;\n  transition: color var(--dur) var(--ease);\n}\n.ftr__bar-link:hover {\n  color: var(--accent);\n}\n\n/* ── Responsive ── */\n@media (max-width: 1099.98px) {\n  .ftr__cta {\n    grid-template-columns:\n      auto\n      clamp(50px, 5vw, 68px)\n      auto;\n  }\n  .innerContent div {\n    min-width: 100%;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .ftr__cta {\n    grid-template-columns: 1fr;\n  }\n\n  .ftr__illustration {\n    display: none;\n  }\n  .ftr__or {\n    flex-direction: row;\n    height: auto;\n    padding: 1rem 2rem;\n    border-top: 1px solid var(--line);\n    border-bottom: 1px solid var(--line);\n  }\n  .ftr__or-line {\n    flex: 1;\n    width: auto;\n    height: 1px;\n  }\n  .ftr__panel {\n    border-left: none;\n    border-right: none;\n    border-bottom: 1px solid var(--line);\n    padding: 2rem var(--gutter);\n  }\n  .ftr__swatches {\n    grid-template-columns: repeat(6, 1fr);\n    height: clamp(52px, 12vw, 80px);\n  }\n  .ftr__swatches-meta,\n  .ftr__swatches-brand {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
